var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClassic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M0 0L18 0 18 18 0 18z",
    transform: "translate(-1108 -536) translate(1096 445) translate(12 91)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6D6E71",
    fillRule: "nonzero",
    d: "M15.75 8.258L2.25 8.25v1.5h13.5V8.258zM2.25 12h9v1.5h-9V12zm13.5-7.5H2.25v1.508L15.75 6V4.5z",
    transform: "translate(-1108 -536) translate(1096 445) translate(12 91)"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClassic);
export default __webpack_public_path__ + "static/media/classic.01db7d27f72ee7f6182ecf9fa325694c.svg";
export { ForwardRef as ReactComponent };